<div class="mw-core-toolbar">
  <div class="mw-core-toolbar__start">
  <div class="mw-core-toolbar__toggler" *ngIf="showToggler">
    <button mat-icon-button (click)="toggle.emit()">
      <mat-icon>menu</mat-icon>
    </button>
  </div>
  <div class="mw-core-toolbar__toggler" *ngIf="allowBack">
    <button mat-icon-button (click)="onBackClick()" color="white">
      <mat-icon fontSet="material-symbols-outlined">arrow_back</mat-icon>
    </button>
  </div>
  <div class="mw-core-toolbar__logo" *ngIf="logo">
    <img
      [attr.src]="logo"
      *ngIf="!showCompactLogo"
      height="32px"
      class="mw-core-toolbar__logo--full"
      (error)="onLogoError($event)"
    />
    <img
      src="assets/img/logo-icon.svg"
      height="32px"
      *ngIf="showCompactLogo"
      class="mw-core-toolbar__logo--compact"
    />
  </div>
  <div class="mw-core-toolbar__title">
    <span (click)="onTitleClick()" [class.cursor-pointer]="clickableTitle">
      {{ title | translate }}
    </span>
  </div>
  </div>
  <div class="mw-core-toolbar__alt-logo">
    <img src="assets/img/logo-alt.png" height="44" width="335" />
  </div>
  <div class="mw-core-toolbar__actions" *ngIf="showActions">
    <button
      mat-icon-button
      (click)="openFullScreen()"
      *ngIf="!isFullScreen && showFullscreenButton"
    >
      <mat-icon>fullscreen</mat-icon>
    </button>
    <button
      mat-icon-button
      (click)="closeFullScreen()"
      *ngIf="isFullScreen && showFullscreenButton"
    >
      <mat-icon>fullscreen_exit</mat-icon>
    </button>
    <ng-content></ng-content>
  </div>
</div>
